<template>
  <div>
    <!-- Hero Section -->
    <section class="bg-hk-cream section-decorated">
      <div class="container mx-auto px-4 py-16 md:py-20 relative z-10">
        <div class="grid md:grid-cols-5 gap-8 items-center">
          <div class="md:col-span-3">
            <p class="text-xl sm:text-2xl md:text-3xl text-hk-dark mb-2">{{ t('home.hero.title') }}</p>
            <p class="text-xl sm:text-2xl md:text-3xl text-hk-dark leading-relaxed">
              <span class="font-bold text-hk-red">Haskrediet</span> {{ t('home.hero.body') }}
            </p>
            <p class="text-base sm:text-lg md:text-xl text-hk-dark leading-relaxed mt-5">{{ t('home.hero.sub1') }}</p>
            <p class="text-base sm:text-lg md:text-xl text-hk-dark leading-relaxed mt-1">{{ t('home.hero.sub1b') }}</p>
            <p class="text-base sm:text-lg md:text-xl font-semibold text-hk-red mt-1">{{ t('home.hero.sub2') }}</p>
            <a href="#simuleer" class="inline-block mt-8 bg-hk-red text-white btn-modern">
              {{ t('footer.simuleer') }}
            </a>
            <!-- Social icons -->
            <!--
            <div class="flex gap-4 mt-6">
            <a href="#" class="text-hk-gray hover:text-hk-red transition-colors">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            </a>
            <a href="#" class="text-hk-gray hover:text-hk-red transition-colors">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385h-3.047v-3.47h3.047v-2.642c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953h-1.514c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385c5.738-.9 10.126-5.864 10.126-11.854z"/></svg>
            </a>
            <a href="#" class="text-hk-gray hover:text-hk-red transition-colors">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667h-3.554v-11.452h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zm-15.11-13.019c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019h-3.564v-11.452h3.564v11.452zm15.106-20.452h-20.454c-.979 0-1.771.774-1.771 1.729v20.542c0 .956.792 1.729 1.771 1.729h20.451c.978 0 1.774-.773 1.774-1.729v-20.542c0-.955-.796-1.729-1.774-1.729z"/></svg>
            </a>
            <a href="#" class="text-hk-gray hover:text-hk-red transition-colors">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136c-1.872-.508-9.376-.508-9.376-.508s-7.504 0-9.376.508a3.017 3.017 0 0 0-2.122 2.136 31.851 31.851 0 0 0-.502 5.814 31.851 31.851 0 0 0 .502 5.814 3.016 3.016 0 0 0 2.122 2.136c1.872.508 9.376.508 9.376.508s7.504 0 9.376-.508a3.015 3.015 0 0 0 2.122-2.136 31.851 31.851 0 0 0 .502-5.814 31.851 31.851 0 0 0-.502-5.814z"/><polygon fill="#F5EFE6" points="9.545,15.568 15.818,12 9.545,8.432"/></svg>
            </a>
            </div>
              -->
          </div>
          <div class="md:col-span-2 flex justify-center">
            <img src="@/assets/img/HKfoto2.png" alt="HasKrediet" class="max-w-full h-auto rounded-2xl shadow-xl" />
          </div>
        </div>
      </div>
    </section>

    <!-- Broker Info -->
    <section class="bg-white section-decorated">
      <div class="container mx-auto px-4 py-16 max-w-4xl relative z-10">
        <h2 class="font-serif text-2xl md:text-3xl font-bold text-hk-dark mb-2">{{ t('home.broker.title') }}</h2>
        <div class="w-16 h-1 bg-hk-red rounded-full mb-8"></div>
        <div class="space-y-3 text-base text-hk-dark leading-relaxed mb-10">
          <p>{{ t('home.broker.intro1') }}</p>
          <p>{{ t('home.broker.intro2') }}</p>
        </div>

        <h3 class="text-xl md:text-2xl font-bold text-hk-red mb-8">{{ t('home.broker.troeven') }}</h3>
        <div class="grid sm:grid-cols-2 gap-6 mb-10">
          <div v-for="item in brokerFeatures" :key="item" class="bg-hk-cream-light rounded-xl p-5 border border-hk-cream-dark/30">
            <p class="font-bold text-hk-dark mb-1">{{ t(`home.broker.${item}.title`) }}</p>
            <p class="text-sm text-hk-gray leading-relaxed">{{ t(`home.broker.${item}.text`) }}</p>
          </div>
        </div>

        <div class="bg-hk-cream-dark rounded-2xl p-8 space-y-3 text-base text-hk-dark leading-relaxed">
          <p class="font-bold text-lg">{{ t('home.broker.closing.title') }}</p>
          <p>{{ t('home.broker.closing.text') }}</p>
          <p class="font-semibold text-hk-red">{{ t('home.broker.closing.tagline') }}</p>
        </div>
      </div>
    </section>

    <!-- Simuleer uw lening -->
    <section id="simuleer" class="bg-hk-cream-dark section-decorated">
      <div class="container mx-auto px-4 py-16 relative z-10">
        <div class="text-center mb-12">
          <h2 class="font-serif text-2xl md:text-3xl font-bold text-hk-dark uppercase tracking-wide">
            {{ t('home.sim.title') }}
          </h2>
          <div class="w-16 h-1 bg-hk-red rounded-full mx-auto mt-3"></div>
          <p class="text-hk-gray mt-4">{{ t('home.sim.subtitle') }}</p>
          <p class="text-sm text-hk-red font-semibold mt-2">{{ t('home.sim.free') }}</p>
        </div>

        <div class="grid md:grid-cols-2 gap-10">
          <div>
            <p class="text-base text-hk-dark leading-relaxed">{{ t('home.sim.body') }}</p>
          </div>

          <div class="card-modern p-6">
            <div class="flex rounded-full overflow-hidden border border-hk-cream-dark mb-6">
              <button
                :class="[
                  'flex-1 py-2.5 text-sm font-bold uppercase tracking-wide transition-colors',
                  simType === 'woon' ? 'bg-hk-red text-white' : 'bg-white text-hk-dark hover:bg-hk-cream'
                ]"
                @click="setSimType('woon')"
              >
                {{ t('sim.type.woon') }}
              </button>
              <button
                :class="[
                  'flex-1 py-2.5 text-sm font-bold uppercase tracking-wide transition-colors',
                  simType === 'loa' ? 'bg-hk-red text-white' : 'bg-white text-hk-dark hover:bg-hk-cream'
                ]"
                @click="setSimType('loa')"
              >
                {{ t('sim.type.loa') }}
              </button>
            </div>
            <div class="space-y-4">
              <div>
                <label class="flex items-center gap-1 text-sm font-medium text-hk-gray mb-1">
                  {{ t('loan.amount') }}
                  <button type="button" @click.stop="showAmountInfo = !showAmountInfo" class="group/info text-hk-red transition-colors">
                    <span class="w-4 h-4 inline-flex items-center justify-center rounded-full border border-current text-xs leading-none transition-colors group-hover/info:bg-hk-red group-hover/info:text-white group-hover/info:border-hk-red">i</span>
                  </button>
                </label>
                <div class="flex items-center gap-2">
                  <span class="text-base text-hk-gray">&euro;</span>
                  <input type="text" inputmode="numeric" v-model="amountDisplay" @blur="onAmountBlur" class="w-full rounded border-gray-300 text-base focus:ring-hk-red focus:border-hk-red" />
                </div>
                <p v-if="amountWarning" class="text-xs text-hk-red mt-1">{{ amountWarning }}</p>
              </div>
              <div>
                <label class="flex items-center gap-1 text-sm font-medium text-hk-gray mb-1">
                  {{ t('loan.rate') }}
                  <button type="button" @click.stop="showRateInfo = !showRateInfo" class="group/info text-hk-red transition-colors">
                    <span class="w-4 h-4 inline-flex items-center justify-center rounded-full border border-current text-xs leading-none transition-colors group-hover/info:bg-hk-red group-hover/info:text-white group-hover/info:border-hk-red">i</span>
                  </button>
                </label>
                <div class="flex items-center gap-2">
                  <input type="number" v-model.number="simRate" :min="0" :max="25" :step="0.01" class="w-full rounded border-gray-300 text-base focus:ring-hk-red focus:border-hk-red" />
                  <span class="text-base text-hk-gray">%</span>
                </div>
              </div>
              <div>
                <label class="flex items-center gap-1 text-sm font-medium text-hk-gray mb-1">
                  {{ t('loan.duration') }}
                  <button type="button" @click.stop="showDurationInfo = !showDurationInfo" class="group/info text-hk-red transition-colors">
                    <span class="w-4 h-4 inline-flex items-center justify-center rounded-full border border-current text-xs leading-none transition-colors group-hover/info:bg-hk-red group-hover/info:text-white group-hover/info:border-hk-red">i</span>
                  </button>
                </label>
                <CustomSelect v-model="simDuration" :options="simConfig.durations" />
              </div>
              <div v-if="rateChosen" class="pt-2 border-t space-y-2">
                <div class="flex justify-between items-center">
                  <span class="text-sm text-hk-gray">{{ t('loan.totalRepay') }}</span>
                  <span class="text-base font-semibold text-hk-dark">{{ formatCurrency(totalRepay) }}</span>
                </div>
                <div class="flex justify-between items-center">
                  <span class="text-sm text-hk-gray">{{ t('loan.totalInterest') }}</span>
                  <span class="text-base font-semibold text-hk-dark">{{ formatCurrency(totalInterest) }}</span>
                </div>
                <div class="flex justify-between items-center pt-2 border-t">
                  <span class="text-base text-hk-gray">{{ t('loan.monthly') }}</span>
                  <span class="text-2xl font-bold text-hk-red">{{ formatCurrency(monthlyPayment) }}</span>
                </div>
              </div>
              <div v-else class="pt-2 border-t">
                <p class="text-sm text-hk-gray text-center py-3">{{ t('loan.chooseRateHint') }}</p>
              </div>
              <button @click="goToContactWithSim" class="w-full bg-hk-red text-white btn-modern py-3">
                {{ t('loan.apply') }}
              </button>
              <p class="text-xs text-hk-gray text-center mt-2">{{ t('loan.disclaimer') }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Form -->
    <section class="bg-hk-cream section-decorated">

      <div class="wave-divider -top-px">
        <svg viewBox="0 0 1440 50" preserveAspectRatio="none" class="w-full h-6 md:h-10">
          <path d="M0,50 C480,0 960,40 1440,10 L1440,0 L0,0 Z" fill="#EDE5D8"/>
        </svg>
      </div>

      <div class="container mx-auto px-4 pt-20 md:pt-28 pb-24 md:pb-32 relative z-10">
        <div class="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h2 class="font-serif text-2xl md:text-3xl text-hk-dark mb-2">
              {{ t('contact.title') }}
            </h2>
            <div class="w-16 h-1 bg-hk-red rounded-full mb-8"></div>
            <form class="space-y-5" @submit.prevent="submitContact">
              <input type="text" v-model="contactForm.firstName" :placeholder="t('contact.firstName')" required class="w-full bg-white border border-hk-cream-dark/40 rounded-xl px-4 py-3 text-base placeholder:text-hk-gray-light focus:border-hk-red focus:ring-1 focus:ring-hk-red/20" />
              <input type="text" v-model="contactForm.lastName" :placeholder="t('contact.lastName')" required class="w-full bg-white border border-hk-cream-dark/40 rounded-xl px-4 py-3 text-base placeholder:text-hk-gray-light focus:border-hk-red focus:ring-1 focus:ring-hk-red/20" />
              <input type="email" v-model="contactForm.email" :placeholder="t('contact.email')" required class="w-full bg-white border border-hk-cream-dark/40 rounded-xl px-4 py-3 text-base placeholder:text-hk-gray-light focus:border-hk-red focus:ring-1 focus:ring-hk-red/20" />
              <input type="tel" v-model="contactForm.phone" :placeholder="t('contact.phone')" class="w-full bg-white border border-hk-cream-dark/40 rounded-xl px-4 py-3 text-base placeholder:text-hk-gray-light focus:border-hk-red focus:ring-1 focus:ring-hk-red/20" />
              <p v-if="contactStatus === 'success'" class="text-green-600 font-semibold">{{ t('contact.success') }}</p>
              <p v-if="contactStatus === 'error'" class="text-red-600 font-semibold">{{ t('contact.error') }}</p>
              <div class="pt-2">
                <button type="submit" :disabled="contactSubmitting" class="bg-hk-red text-white btn-modern disabled:opacity-50">
                  {{ contactSubmitting ? '...' : t('contact.send') }}
                </button>
              </div>
            </form>
          </div>
          <div class="flex flex-col items-center justify-center text-center">
            <div class="card-modern p-8 max-w-sm">
              <h3 class="font-serif text-xl font-semibold text-hk-red mb-4">{{ t('contact.bubble') }}</h3>
              <p class="text-base text-hk-dark leading-relaxed">{{ t('contact.bubbleText') }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Info popups -->
    <div v-if="showAmountInfo || showRateInfo || showDurationInfo" class="fixed inset-0 z-50 flex items-center justify-center px-4" @click.self="closePopups">
      <div class="fixed inset-0 bg-black/30" @click="closePopups"></div>
      <div class="relative bg-white border border-hk-red/30 rounded-2xl p-6 max-w-sm w-full shadow-xl">
        <button @click="closePopups" class="absolute top-3 right-3 text-hk-gray hover:text-hk-red transition-colors">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
        <p v-if="showAmountInfo" class="text-sm text-hk-red leading-relaxed">{{ t(`loan.amountInfo.${simType}`) }}</p>
        <p v-if="showRateInfo" class="text-sm text-hk-red leading-relaxed">{{ t('loan.rateInfo') }}</p>
        <div v-if="showDurationInfo">
          <p class="text-sm text-hk-red leading-relaxed mb-3">{{ t(`loan.durationInfo.${simType}`) }}</p>
          <table v-if="simType === 'loa'" class="w-full text-sm text-hk-red border-collapse">
            <thead>
              <tr class="border-b border-hk-red/20">
                <th class="text-left py-1.5 text-hk-red font-semibold">{{ t('loan.durationTable.amount') }}</th>
                <th class="text-right py-1.5 text-hk-red font-semibold">{{ t('loan.durationTable.maxDuration') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in durationTable" :key="row.max" class="border-b border-hk-cream-dark/30">
                <td class="py-1.5">{{ row.label }}</td>
                <td class="text-right py-1.5">{{ row.duration }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, computed, watch } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "@/i18n";
import CustomSelect from "@/components/CustomSelect.vue";

const FORMSUBMIT_URL = "https://formsubmit.co/ajax/hasweb@haskrediet.be";

const router = useRouter();
const { t } = useI18n();
const brokerFeatures = ['ervaring', 'persoonlijk', 'onafhankelijk', 'begeleiding', 'vertrouwen', 'aanbod'];

const showAmountInfo = ref(false);
const showRateInfo = ref(false);
const showDurationInfo = ref(false);
const closePopups = () => { showAmountInfo.value = false; showRateInfo.value = false; showDurationInfo.value = false; };

const durationTable = computed(() => {
  const rows = [
    { max: 2500, months: 24 },
    { max: 3700, months: 30 },
    { max: 5600, months: 36 },
    { max: 7500, months: 42 },
    { max: 10000, months: 48 },
    { max: 15000, months: 60 },
    { max: 20000, months: 84 },
    { max: 37000, months: 120 },
  ];
  return [
    ...rows.map((r, i) => {
      const min = i === 0 ? 500 : rows[i - 1].max + 0.01;
      return { label: `${formatCurrency(min)} - ${formatCurrency(r.max)}`, duration: formatDuration(r.months) };
    }),
    { label: `${formatCurrency(37000.01)} - ${formatCurrency(99999.99)}`, duration: formatDuration(180) },
  ];
});

type SimType = 'woon' | 'loa';
const simType = ref<SimType>('woon');
const simAmount = ref(150000);
const simRate = ref(0);
const simDuration = ref(240);

const loaMaxMonths = (amount: number): number => {
  if (amount <= 2500) return 24;
  if (amount <= 3700) return 30;
  if (amount <= 5600) return 36;
  if (amount <= 7500) return 42;
  if (amount <= 10000) return 48;
  if (amount <= 15000) return 60;
  if (amount <= 20000) return 84;
  if (amount <= 37000) return 120;
  return 180;
};

const formatDuration = (months: number) => {
  const years = months / 12;
  if (years < 1) return `${months} ${t('loan.months')}`;
  const formatted = years % 1 === 0 ? `${years}` : `${years.toFixed(1).replace('.', ',')}`;
  return `${formatted} ${t('woon.sim.years')} (${months} ${t('loan.months')})`;
};

const loaDurations = computed(() => {
  const max = loaMaxMonths(simAmount.value);
  const all = [12, 18, 24, 30, 36, 42, 48, 60, 84, 120, 180];
  return all.filter(m => m <= max).map(m => ({ value: m, label: formatDuration(m) }));
});

const woonDurations = [5, 10, 15, 20, 25, 30].map(y => ({
  value: y * 12,
  get label() { return `${y} ${t('woon.sim.years')} (${y * 12} ${t('loan.months')})`; }
}));

const simConfig = computed(() => {
  if (simType.value === 'woon') {
    return {
      minAmount: 25000, maxAmount: 3000000, amountStep: 5000,
      durations: woonDurations,
    };
  }
  return {
    minAmount: 500, maxAmount: 99999.99, amountStep: 100,
    durations: loaDurations.value,
  };
});

const setSimType = (type: SimType) => {
  simType.value = type;
  if (type === 'woon') {
    simAmount.value = 150000;
    simRate.value = 0;
    simDuration.value = 240;
  } else {
    simAmount.value = 8000;
    simRate.value = 0;
    simDuration.value = 48;
  }
  amountDisplay.value = formatNum(simAmount.value);
};

const amountWarning = ref('');
let warningTimer: ReturnType<typeof setTimeout>;

watch(simAmount, (amt) => {
  const max = simConfig.value.maxAmount;
  if (amt > max) {
    simAmount.value = max;
    amountDisplay.value = formatNum(max);
    amountWarning.value = t('loan.maxAmount', { max: formatCurrency(max) });
    clearTimeout(warningTimer);
    warningTimer = setTimeout(() => { amountWarning.value = ''; }, 3000);
    return;
  }
  if (simType.value === 'loa') {
    const maxMonths = loaMaxMonths(amt);
    if (simDuration.value > maxMonths) simDuration.value = maxMonths;
  }
});

const rateChosen = computed(() => simRate.value > 0);

const monthlyPayment = computed(() => {
  const rate = simRate.value / 100 / 12;
  const n = simDuration.value;
  const pv = simAmount.value;
  if (rate === 0) return pv / n;
  return (pv * rate * Math.pow(1 + rate, n)) / (Math.pow(1 + rate, n) - 1);
});

const totalRepay = computed(() => monthlyPayment.value * simDuration.value);
const totalInterest = computed(() => totalRepay.value - simAmount.value);

const formatCurrency = (value: number) => {
  return new Intl.NumberFormat("nl-BE", { style: "currency", currency: "EUR" }).format(value);
};

const formatNum = (n: number) => n > 0 ? new Intl.NumberFormat('nl-BE', { maximumFractionDigits: 0 }).format(n) : '';
const amountDisplay = ref(formatNum(simAmount.value));

watch(amountDisplay, (val) => {
  const num = parseInt(val.replace(/\./g, ''), 10);
  if (!isNaN(num) && num >= 0) simAmount.value = num;
});

const onAmountBlur = () => {
  amountDisplay.value = formatNum(simAmount.value);
};

const goToContactWithSim = () => {
  const typeLabel = simType.value === 'woon' ? t('sim.type.woon') : t('sim.type.loa');
  const msg = `${typeLabel}\n${t('loan.amount')}: ${formatCurrency(simAmount.value)}\n${t('loan.rate')}: ${simRate.value}%\n${t('loan.duration')}: ${simDuration.value} ${t('loan.months')}\n${t('loan.monthly')}: ${formatCurrency(monthlyPayment.value)}`;
  router.push({ name: "contact", query: { message: msg } });
};

const contactSubmitting = ref(false);
const contactStatus = ref<"" | "success" | "error">("");
const contactForm = reactive({
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
});

const submitContact = async () => {
  contactSubmitting.value = true;
  contactStatus.value = "";
  try {
    const res = await fetch(FORMSUBMIT_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        _subject: "Nieuw contact via homepage - Haskrediet",
        Voornaam: contactForm.firstName,
        Naam: contactForm.lastName,
        Email: contactForm.email,
        Telefoon: contactForm.phone,
        _template: "table",
      }),
    });
    if (!res.ok) throw new Error();
    contactStatus.value = "success";
    contactForm.firstName = "";
    contactForm.lastName = "";
    contactForm.email = "";
    contactForm.phone = "";
  } catch {
    contactStatus.value = "error";
  } finally {
    contactSubmitting.value = false;
  }
};
</script>
